// TODO: Remove this file after modularization is done
export const clientsUsingContracts = [
  'astara.evx.cl',
  'dev.evx.cl',
  'staging.evx.cl',
  'danco.evx.cl',
  'sandbox.evx.cl',
  'demo.evx.cl',
  'enerlink.evx.cl',
  'colbun.evx.cl',
  'chargeway.evx.cl',
  'cge.evx.cl',
  'eproqa.enex.cl',
  'eproprod.enex.cl',
  'voltway.evx.cl',
  'sotraser.evx.cl',
  'tattersall.evx.cl',
  'kaufmann.evx.cl',
  'enelxway-peru.evx.cl',
  'enelx-co.evx.cl',
  'e-pereira.evx.cl',
  'epm.evx.cl',
  'edeq.evx.cl',
  'liverpool.evx.cl',
  'goenergy.evx.cl',
  'grupocarrera.evx.cl',
  'cityenergy.evx.cl',
  'epm.evx.cl',
  'tecsur.evx.cl',
  'akron.evx.cl',
  'chec.evx.cl',
  'paleson.evx.cl',
  'jac-ec.evx.cl',
  'marva.evx.cl',
  'essa.evx.cl',
  'autoeastern.evx.cl',
  'localhost:8000',
];

export const clientsUsingSales = [
  'dev.evx.cl',
  'astara.evx.cl',
  'staging.evx.cl',
  'cge.evx.cl',
  'demo.evx.cl',
  'sandbox.evx.cl',
  'enerlink.evx.cl',
  'kaufmann.evx.cl',
  'colbun.evx.cl',
  'eproqa.enex.cl',
  'eproprod.enex.cl',
  'voltway.evx.cl',
  'danco.evx.cl',
  'sotraser.evx.cl',
  'tattersall.evx.cl',
  'chargeway.evx.cl',
  'enelxway-peru.evx.cl',
  'enelx-co.evx.cl',
  'e-pereira.evx.cl',
  'epm.evx.cl',
  'edeq.evx.cl',
  'liverpool.evx.cl',
  'goenergy.evx.cl',
  'grupocarrera.evx.cl',
  'cityenergy.evx.cl',
  'epm.evx.cl',
  'tecsur.evx.cl',
  'akron.evx.cl',
  'chec.evx.cl',
  'paleson.evx.cl',
  'jac-ec.evx.cl',
  'marva.evx.cl',
  'essa.evx.cl',
  'autoeastern.evx.cl',
  'localhost:8000',
];

export const clientsUsingAzureSSO: string[] = [
  // 'localhost',
  // 'evx-sandbox.enerlink.com',
  'backofficeeproqa.enex.cl',
  'backofficeeproprod.enex.cl',
];
